import { disablePageScroll, enablePageScroll } from 'scroll-lock';

const $ = jQuery.noConflict();

class Search {
    constructor() {
        this.header = '.main-header';
        this.modal = '.search-modal';
        this.form = '.search-form';
        this.input = '.search-form__input';
        this.submitBtn = '.search-form__submit';
        this.resetBtn = '.search-form__reset';
        this.content = '.search-modal__content';
    }

    init() {
        this.toggleVisibility();
        this.resetForm();
        this.submitForm();
        this.resized();
    }

    toggleVisibility() {
        $('.main-header__search, .search-modal__close, .search-modal__close-mobile').on('click', event => {
            event.preventDefault();

            if ($(this.modal).length) {
                if ($(this.modal).is(':visible')) {
                    enablePageScroll();
                    if (window.matchMedia('(min-width: 1200px)').matches) {
                        $(this.modal).slideUp(200);
                    } else {
                        $(this.modal).hide();
                    }
                } else {
                    disablePageScroll();
                    if (window.matchMedia('(min-width: 1200px)').matches) {
                        $(this.modal).slideDown(200);
                    } else {
                        $(this.modal).show();
                    }
                    $('.btn-hamburger').removeClass('open').next().removeClass('active');
                    $('.search-form .search-form__input').focus();
                }
            } else {
                $('html, body').animate({ scrollTop: $(this.form).offset().top - $(this.header).height() - 20 }, 400);
            }
        });
    }

    resetForm() {
        $(this.resetBtn).on('click', event => {
            const form = $(event.currentTarget).parent();
            $(event.currentTarget).hide();
            form.find(this.submitBtn).removeAttr('style');
            form.find(this.input).val('');
            $(this.content).html('');
        });
    }

    submitForm() {
        $(this.form).on('submit', event => {
            event.preventDefault();
            const form = $(event.currentTarget);
            form.find(this.input).blur();
            const url = `${$(this.form)[0].action}?${$(this.form).serialize()}`;

            $.ajax({
                url: url,
                type: 'GET',
                beforeSend: () => {
                    $(`${this.form}, ${this.content}`).addClass('loading');
                },
                success: data => {
                    const content = $(data).find(this.content).html().trim();
                    $(this.content).html(content);
                    form.find(this.submitBtn).hide();
                    form.find(this.resetBtn).removeAttr('style');
                },
                complete: () => {
                    $(`${this.form}, ${this.content}`).removeClass('loading');
                }
            });
        });
    }

    resized() {
        if (window.matchMedia('(min-width: 1200px)').matches) {
            $(this.modal).css({
                'top': `${$(this.header).height()}px`,
                'height': `${window.innerHeight - $(this.header).height()}px`,
            });
        } else {
            $(this.modal).css({
                'top': `0`,
                'height': `${window.innerHeight}px`,
            });
        }

        $('.search-modal__close-mobile').css({ 'height': `${$('.main-header__wrapper').height()}px`, });
    }
}

export default new Search();
